// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","tertiary":"#BFD730","icon":"_3dwM","l1":"_1Ui0","l2":"_3ai_","l3":"_6mCP","active":"fB6V","back":"_2zfd"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Icons/Menu/Menu.scss
// module id = Ed77
// module chunks = 0